export default "__VITE_ASSET__D8Tc8_y9__"